"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareStepFormSchema = exports.sharePriceStepSchema = void 0;
const yup = __importStar(require("yup"));
const moment_1 = __importDefault(require("moment"));
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const constants_1 = require("../constants");
exports.sharePriceStepSchema = {
    calculationMethod: yup.string().required(constants_1.CALCULATION_METHOD_REQUIRED),
    amountPaid: yup.number().when("calculationMethod", {
        is: constants_1.TOTAL_PAID_AMOUNT,
        then: yup
            .number()
            .typeError(constants_1.AMOUNT_REQUIRED)
            .test("amountPaid", constants_1.AMOUNT_REQUIRED, (amountPaid) => amountPaid !== undefined)
            .test("amountPaid", constants_1.AMOUNT_NOT_NEG, (amountPaid) => amountPaid >= 0),
        otherwise: yup.number().notRequired(),
    }),
    quantityForAmountPaid: yup.number().when("calculationMethod", {
        is: constants_1.TOTAL_PAID_AMOUNT,
        then: yup
            .number()
            .typeError(constants_1.NO_OF_SHARES_REQUIRED)
            .test("quantityForAmountPaid", constants_1.NO_OF_SHARES_REQUIRED, (quantityForAmountPaid) => quantityForAmountPaid !== undefined)
            .positive(constants_1.NO_OF_SHARES_POSITIVE)
            .integer(constants_1.INTEGER_REQUIRED)
            .test("quantityForAmountPaid", "Quantity cannot be more than available shares in selected share class", function test(quantityForAmountPaid) {
            if (this.options.context) {
                const { isTransfer, shareClass, maxQuantity, method } = this.options.context;
                if (!isTransfer && !shareClass)
                    return true;
                if (method === constants_1.TOTAL_PAID_AMOUNT && shareClass) {
                    return quantityForAmountPaid <= maxQuantity;
                }
            }
            return true;
        }),
        otherwise: yup.number().notRequired(),
    }),
    quantity: yup.number().when("calculationMethod", {
        is: constants_1.PRICE_PER_SHARE,
        then: yup
            .number()
            .typeError(constants_1.NO_OF_SHARES_REQUIRED)
            .test("quantity", constants_1.NO_OF_SHARES_REQUIRED, (quantity) => quantity !== undefined)
            .positive(constants_1.NO_OF_SHARES_POSITIVE)
            .integer(constants_1.INTEGER_REQUIRED)
            .test("quantity", "Quantity cannot be more than available shares in selected share class", function test(quantity) {
            if (this.options.context) {
                const { isTransfer, shareClass, maxQuantity, method } = this.options.context;
                if (!isTransfer && !shareClass)
                    return true;
                if (method === constants_1.PRICE_PER_SHARE && shareClass) {
                    return quantity <= maxQuantity;
                }
            }
            return true;
        }),
        otherwise: yup.number().notRequired(),
    }),
    pricePerShare: yup.number().when("calculationMethod", {
        is: constants_1.PRICE_PER_SHARE,
        then: yup
            .number()
            .typeError(constants_1.PRICE_PER_SHARE_REQUIRED)
            .test("pricePerShare", constants_1.PRICE_PER_SHARE_REQUIRED, (pricePerShare) => pricePerShare !== undefined)
            .test("pricePerShare", constants_1.PRICE_PER_SHARE_NOT_NEG, (pricePerShare) => pricePerShare >= 0),
        otherwise: yup.number().notRequired(),
    }),
};
exports.ShareStepFormSchema = yup.object().shape(Object.assign(Object.assign({}, exports.sharePriceStepSchema), { shareClassId: yup.string().trim().required(constants_1.SHARE_CLASS_REQUIRED), dateOfTransaction: yup
        .string()
        .trim()
        .required(constants_1.DATE_REQUIRED)
        .test("dateOfTransaction", constants_1.DATE_VALID, (dateOfTransaction) => !!dateOfTransaction && (0, moment_1.default)(dateOfTransaction).isValid() && (0, mystake_common_sdk_1.getDateYear)(dateOfTransaction) > 1920)
        .test("dateOfTransaction", constants_1.DATE_OF_ISSUE_NOT_FUTURE, (dateOfTransaction) => (0, moment_1.default)(dateOfTransaction).diff((0, moment_1.default)(), "days") <= 0)
        .test("dateOfTransaction", constants_1.DATE_NOT_PRIOR_TO_COMPANY_REGISTRATION, function test(dateOfTransaction) {
        if (this.options.context) {
            const { dateOfRegistration } = this.options.context;
            if (dateOfRegistration) {
                return new Date(dateOfRegistration).getTime() - constants_1.MILLISECONDS_PER_DAY < new Date(dateOfTransaction).getTime();
            }
        }
        return true;
    }) }));
//# sourceMappingURL=ShareStepFormSchema.js.map